import * as React from "react";
import BackButton from "../../core/BackButton/BackButton";
import Spinner from "../../core/Spinner/Spinner";
import { ITranslationProps, translateComponent } from "../../helpers/translation";

interface IForgotPasswordProps extends ITranslationProps {
    onSubmit: (email: string) => Promise<boolean>;
}

interface IForgotPasswordState {
    email: string;
    validated: boolean;

    requestFailed: boolean;
    requestSuccess: boolean;
    processing: boolean;
}

class ForgotPassword extends React.Component<IForgotPasswordProps, IForgotPasswordState> {
    private formElement: HTMLFormElement | null;

    constructor(props: IForgotPasswordProps) {
        super(props);

        this.state = {
            email: "",
            validated: false,
            requestFailed: false,
            requestSuccess: false,
            processing: false,
        };

        this.onEmailChange = this.onEmailChange.bind(this);
        this.onGetForgotPasswordLink = this.onGetForgotPasswordLink.bind(this);
        this.inputKeypress = this.inputKeypress.bind(this);
    }

    public render() {
        return (
            <div>
                {this.state.processing && <Spinner />}
                <BackButton />
                <h2>{this.props.t("ForgotPassword.Title")}</h2>
                <div className="mb-3">{this.props.t("ForgotPassword.Instructions")}</div>
                <form ref={ref => this.formElement = ref} className={this.state.validated ? "was-validated" : "needs-validation"} noValidate={true}>
                    <div className="form-group">
                        <label>{this.props.t("ForgotPassword.EmailAddress")}</label>
                        <input
                            type="email"
                            className="form-control"
                            placeholder={this.props.t("ForgotPassword.EmailAddress")}
                            value={this.state.email}
                            onChange={this.onEmailChange}
                            onKeyPress={this.inputKeypress}
                            required={true}
                            autoFocus={true} />

                        <div className="invalid-feedback">
                            {this.props.t("ForgotPassword.EmailValidationMessage")}
                        </div>
                    </div>

                    <button type="button" className="btn btn-primary" onClick={this.onGetForgotPasswordLink}>{this.props.t("ForgotPassword.GetLinkButton")}</button>

                    {this.state.requestFailed && <div className="mt-3 alert alert-danger">{this.props.t("ForgotPassword.FailureMessage")}</div>}
                    {this.state.requestSuccess && <div className="mt-3 alert alert-success">{this.props.t("ForgotPassword.SuccessMessage")}</div>}
                </form>
            </div>
        );
    }


    private onEmailChange(event: React.ChangeEvent<HTMLInputElement>): void {
        this.setState({ email: event.target.value });
    }

    private inputKeypress(event: React.KeyboardEvent<HTMLInputElement>) {
        if (event.key === "Enter") {
            event.preventDefault();
            this.onGetForgotPasswordLink();
        }
    }

    private async onGetForgotPasswordLink(): Promise<void> {
        this.setState({ validated: true });

        if (this.formElement && this.formElement.checkValidity()) {
            this.setState({ processing: true }, async () => {
                const result = await this.props.onSubmit(this.state.email);
                this.setState({ requestSuccess: result, requestFailed: !result, processing: false });
            });
        }
    }

}

export default translateComponent(ForgotPassword);



// WEBPACK FOOTER //
// ./src/components/ForgotPassword/ForgotPassword.tsx